import { createModule } from '~/factories/store'
import getters from '~/store/modules/shared/admin/categories/getters'
import mutations from '~/store/modules/shared/admin/categories/mutations'
import state from '~/store/modules/shared/admin/categories/state'
import actions from '~/store/modules/shared/admin/categories/actions'

export default createModule({
  getters,
  mutations,
  actions,
  state
})
